import React from 'react';

const BoxAnnotationIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg style={{ width: '100%', display: 'block' }} viewBox="0 0 87 87" {...props}>
    <g fillRule="nonzero" fill="none">
      <rect fill={props.color || '#63B31C'} x={0.4} y={0.4} width={86.6} height={86.6} rx={43.3} />
      <g fill="#FFF">
        <path
          opacity={0.5}
          d="M67.14 30.17L43.7 16.64v9.02l-7.81-4.51v9.02l-7.82-4.51v9.02l-7.81-4.51v27.06L43.7 70.76v-9.02l7.81 4.51v-9.02l7.81 4.51v-9.02l7.82 4.51z"
        />
        <path
          opacity={0.5}
          d="M59.32 34.68L35.89 21.15v9.02l-7.82-4.51v9.02l-7.81-4.51v27.06L43.7 70.76v-9.02l7.81 4.51v-9.02l7.81 4.51z"
        />
        <path
          opacity={0.5}
          d="M51.51 39.19L28.07 25.66v9.02l-7.81-4.51v27.06L43.7 70.76v-9.02l7.81 4.51z"
        />
        <path opacity={0.9} d="M20.26 30.17v27.06L43.7 70.76V43.7z" />
      </g>
    </g>
  </svg>
);

export default BoxAnnotationIcon;
